import { Address } from './types';

export function processFullAddress(address: Address): Address {
  // Build street address with unit number first if present
  let streetAddress = address.streetAddress1 || '';
  if (address.streetAddress2) {
    streetAddress = `${address.streetAddress2}/${streetAddress}`;
  }

  const addressElements = [
    streetAddress,
    address.locality,
    address.state,
    address.postcode,
  ].filter((element) => {
    if (!element) {
      return false;
    }

    if (typeof element === 'string' && element.trim() === '') {
      return false;
    }

    return true;
  });

  return {
    ...address,
    fullAddress: addressElements.join(', ').trim(),
  };
}
